import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { translate } from '../../Services/translation';

const QuickOrder = () => {
  const quickOrderPageUrl = window.__litium.quickOrderPageUrl;

  return (
    <HeaderButton
      icon="Check-Menu"
      label={translate('general.quickorder')}
      hideOnMobile={true}
      renderAsLink={true}
      linkUrl={quickOrderPageUrl}
    />
  );
};

export default QuickOrder;
